/**
 * La pillola in basso a destra che apre l'assistente.
 *
 * Compare con un piccolo ritardo dopo il caricamento, perche' un bottone che
 * salta fuori insieme alla pagina distrae; quando il pannello e' aperto si
 * riduce a un cerchio con la freccia, che lo riduce a icona.
 */

import { forwardRef } from "react";
import marchioAstra from "../assets/astra-mark.svg";
import { IconaFreccia } from "./icone";

interface Proprieta {
  aperto: boolean;
  visibile: boolean;
  nonLetto: boolean;
  onClick: () => void;
}

export const Launcher = forwardRef<HTMLButtonElement, Proprieta>(function Launcher(
  { aperto, visibile, nonLetto, onClick },
  ref,
) {
  const classi = [
    "assistente-launcher",
    visibile ? "assistente-launcher--visibile" : "",
    aperto ? "assistente-launcher--aperto" : "",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <button
      ref={ref}
      type="button"
      className={classi}
      onClick={onClick}
      aria-label={aperto ? "Riduci l'assistente" : "Apri l'assistente alla trasparenza"}
      aria-expanded={aperto}
      aria-controls="assistente-pannello"
    >
      <span className="assistente-launcher__icona">
        {aperto ? (
          <IconaFreccia dimensione={22} />
        ) : (
          <img className="assistente-launcher__marchio" src={marchioAstra} alt="" />
        )}
        {!aperto && nonLetto ? <span className="assistente-launcher__punto" aria-hidden="true" /> : null}
      </span>
      {!aperto ? (
        <span className="assistente-launcher__testo">
          <span className="assistente-launcher__titolo">Serve aiuto?</span>
          <span className="assistente-launcher__sottotitolo">Chiedi all'assistente</span>
        </span>
      ) : null}
    </button>
  );
});
